import styled from 'styled-components';

import constants from '../../constants';
import { DeliveryTip } from '../../order/schemas';
import { formatPrice } from '../../util/format';

interface TotalsProps {
  subTotal?: string;
  taxAndTotal?: string;
  taxAmount?: string;
  isLoading?: boolean;
  promoFreeActive?: boolean;
  deliveryTip?: DeliveryTip;
  deliveryTipIsDisplayed?: boolean;
  className?: string;
}

const Totals: React.FC<TotalsProps> = ({
  subTotal,
  taxAndTotal,
  isLoading,
  className,
  deliveryTip,
  deliveryTipIsDisplayed,
  promoFreeActive,
  taxAmount,
}) => {
  //This will prevent showing negative taxes passed from data range api call
  const isNegativeTax = taxAmount?.includes('$-');
  return (
    <StyledTotals className={className}>
      {(subTotal !== constants.ZERO_DOLLARS || deliveryTipIsDisplayed || promoFreeActive) && (
        <>
          <div className="row-container">
            <Spacer />
            <div style={{ fontWeight: 'bold', textAlign: 'right', flex: 1 }}>Subtotal</div>
            {isLoading ? (
              <div style={{ color: '#e5e0e0', textAlign: 'right', flex: 1 }}>Calculating</div>
            ) : (
              <div data-cy="subtotal" style={{ textAlign: 'right', flex: 1 }}>
                {subTotal}
              </div>
            )}
          </div>
          {taxAmount !== constants.ZERO_DOLLARS && !isNegativeTax && (
            <div className="row-container">
              <Spacer />
              <div className="taxAmount" style={{ fontWeight: 'bold', textAlign: 'right', flex: 1 }}>
                Tax
              </div>
              {isLoading ? (
                <div style={{ color: '#e5e0e0', textAlign: 'right', flex: 1 }}>Calculating</div>
              ) : (
                <div id="tax-and-total" style={{ textAlign: 'right', flex: 1 }}>
                  {taxAmount}
                </div>
              )}
            </div>
          )}
          {deliveryTipIsDisplayed && (
            <div className="row-container">
              <Spacer />
              <div style={{ fontWeight: 'bold', textAlign: 'right', flex: 1 }}>Tip</div>
              {isLoading ? (
                <div style={{ color: '#e5e0e0', textAlign: 'right', flex: 1 }}>Calculating</div>
              ) : (
                <div className="tipAmount" id="tax-and-total" style={{ textAlign: 'right', flex: 1 }}>
                  {formatPrice(deliveryTip?.tipAmount)}
                </div>
              )}
            </div>
          )}
          <div className="row-container">
            <Spacer />
            <div className="taxAndTotal" style={{ fontWeight: 'bold', textAlign: 'right', flex: 1 }}>
              Total
            </div>
            {isLoading ? (
              <div style={{ color: '#e5e0e0', textAlign: 'right', flex: 1 }}>Calculating</div>
            ) : (
              <div id="tax-and-total" style={{ textAlign: 'right', flex: 1 }}>
                {taxAndTotal}
              </div>
            )}
          </div>
        </>
      )}
    </StyledTotals>
  );
};

const StyledTotals = styled.div`
  font: ${(props) => props.theme.regularTextFont};
  color: ${(props) => props.theme.colors.text};
  clear: both;
  padding-top: 1px;

  & .all-totals {
    padding-top: 1px;
  }

  & .row-container {
    display: flex;
    line-height: 27px;
    margin-bottom: 5px;
  }

  & .bold {
    font-weight: bold;
  }
`;

const Spacer = styled.div`
  flex: 3;
`;

export default Totals;
